import { GetTimeFromTimestamp,PriceComparison } from '@dave/types';



export class PriceComparisonEntity {
    constructor(
        public Id: number = null,
        public LedgerImportId: number = null,
        public SkontoPercent: number = null,
        public RabattPercent: number = null,
        public SupplierId: number = null,
        public PositionData: string = null,
        public PartnerId: number = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
        public DeletedAt: Date = null,
        public FileName: string = null,
    ) {}

    public static EntityName = 'PriceComparison';
    public Clone(override: Partial<PriceComparisonEntity> = {}): PriceComparisonEntity {
        const attr = { ...this, ...override };
        return Object.assign(new PriceComparisonEntity(), attr);
    }
}

export function PriceComparisonEntityFromBackend(res: PriceComparison): PriceComparisonEntity {

    return new PriceComparisonEntity(
        res.Id && +res.Id,
        res.LedgerImportId && +res.LedgerImportId,
        res.SkontoPercent && +res.SkontoPercent,
        res.RabattPercent && +res.RabattPercent,
        res.SupplierId && +res.SupplierId,
        res.PositionData,
        res.PartnerId && +res.PartnerId,
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.DeletedAt && GetTimeFromTimestamp(+res.DeletedAt),
        res.FileName,
    );
}
